module.exports = __webpack_public_path__ + "img/700-9c7f94.png";